import { styled } from 'styled-components'

export const WebsitePageBodyContainer = styled.div`
  /** ------------------------------------------------------------
    * NOTE: this hack prevent margin collapsing
    * https://app.shortcut.com/systeme/story/74716/margin-affects-website-content
    * https://habr.com/ru/articles/257327/ */
    border: solid transparent;
    border-width: 1px 0;
  /* ------------------------------------------------------------ */
`
